export default __webpack_public_path__ + "static/media/093-left-arrow-5.a03ce594.png";